module.exports = __webpack_public_path__ + "static/media/beach.bec7cb22.svg";